import * as yup from 'yup';
import config from '@config/index';
import { calendarDateSchema } from '@shared/schemas/calendarDate.schema';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import type { TItem } from '@modules/items/types/items.types';
import { TASK_DESCRIPTION_MAX_LENGTH } from '../constants';
import { ETaskPriority, type TTaskFormValues } from '../types';

export const DEFAULT_TASK_FORM: TTaskFormValues = {
  title: '',
  description: '',
  assignee: null,
  dueDate: null,
  priority: [ETaskPriority.NONE],
  linkedItems: [],
};

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/tasks/dtos/tasks.dto.ts
export const taskFormSchema: yup.ObjectSchema<TTaskFormValues> = yup.object({
  title: yup.string().trim().required(`Enter a ${TERMINOLOGY.task.lower} title.`).max(config.ITEM_NAME_MAX_LENGTH),
  description: yup.string().defined().max(TASK_DESCRIPTION_MAX_LENGTH),
  assignee: yup.string().nullable().defined(),
  dueDate: calendarDateSchema,
  priority: yup
    .array()
    .of(yup.mixed<ETaskPriority>().oneOf(Object.values(ETaskPriority)).required())
    .required()
    .length(1),
  linkedItems: yup.array().of(yup.mixed<TItem>().required()).required(),
});
